import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FileInput from '../../shared/FileInput'

const MAX_ERRORS_DISPLAYED = 6

const ImportationStep = ({
  collectId,
  file,
  validationResult,
  validating,
  error,
  onFileChange
}) => {
  const handleDeleteFile = useCallback(() => {
    onFileChange(null)
  }, [onFileChange])

  const handleDownloadErrorReport = useCallback(() => {
    window.location.href = `/collects/${collectId}/import/error_report`
  }, [collectId])

  const hasErrors = validationResult && !validationResult.success
  const errors = validationResult?.errors || []
  const displayedErrors = errors.slice(0, MAX_ERRORS_DISPLAYED)
  const remainingErrorsCount = errors.length - MAX_ERRORS_DISPLAYED

  return (
    <div>
      <p className="font-weight-bolder mb-2">
        Sélectionnez votre fichier Excel
      </p>
      <FileInput
        accept=".xlsx,.xls"
        buttonClass="btn-light border"
        buttonText={(
          <>
            <i className="fas fa-upload mr-2" />
            <span>Parcourir</span>
          </>
        )}
        errors={error && !hasErrors ? [error] : null}
        placeholder=""
        value={file?.name || ''}
        onChange={onFileChange}
        onDelete={handleDeleteFile}
      />
      {validating ? (
        <div className="alert alert-info-blue mt-3 d-flex align-items-center">
          <i className="fas fa-sync fa-spin mr-2" />
          <span>Vérification du fichier... Veuillez patienter un instant</span>
        </div>
      ) : null}
      {hasErrors ? (
        <div
          className="mt-3 p-3 rounded"
          style={{ backgroundColor: '#FDF2F2' }}
        >
          <p className="text-danger font-weight-bolder mb-2">
            Des erreurs ont été détectées. Veuillez les corriger avant de réimporter le fichier :
          </p>
          <div className="text-danger mb-3">
            {displayedErrors.map((validationError, index) => (
              <div key={index} className="mb-1">
                <strong>
                  Colonne
                  {' '}
                  {validationError.column}
                  {validationError.row ? (
                    <>
                      , ligne
                      {' '}
                      {validationError.row}
                    </>
                  ) : null}
                  {' '}
                  :
                </strong>
                {' '}
                {validationError.message}
                {' '}
                ;
              </div>
            ))}
          </div>
          {remainingErrorsCount > 0 ? (
            <p className="text-danger mb-3">
              (+
              {remainingErrorsCount}
              {' '}
              autres erreurs détectées)
            </p>
          ) : null}
          <button
            type="button"
            className="btn btn-danger btn-block"
            onClick={handleDownloadErrorReport}
          >
            <i className="fas fa-download mr-2" />
            <span>Télécharger le rapport d&apos;erreurs</span>
          </button>
        </div>
      ) : null}
    </div>
  )
}

ImportationStep.propTypes = {
  collectId: PropTypes.number.isRequired,
  error: PropTypes.string,
  file: PropTypes.shape({
    name: PropTypes.string
  }),
  onFileChange: PropTypes.func.isRequired,
  validating: PropTypes.bool.isRequired,
  validationResult: PropTypes.shape({
    errors: PropTypes.arrayOf(PropTypes.shape({
      column: PropTypes.string,
      message: PropTypes.string,
      row: PropTypes.number
    })),
    success: PropTypes.bool.isRequired
  })
}

ImportationStep.defaultProps = {
  error: null,
  file: null,
  validationResult: null
}

export default ImportationStep
